import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { RADIO_BUTTON } from '../utils';
import Field from '@app/components/common/form/Field';
import { getAvailability } from '../../common/commonUtils';
import { Radio } from 'cat-ecommerce-alloy';
import UnitPriceTableCell from '../../common/UnitPriceTableCell';

const SOSTableMobileView = ({ item, currency, sourcingToggle }) => {
  const [t] = useTranslation();
  const isStoreAvailabilityEnabled = useSelector(
    s => s.dealer?.isStoreAvailabilityEnabled
  );
  const hoseAvailabilityLabel = useSelector(
    s => s.common?.hoseAvailabilityLabel
  );
  const getRadio = () => {
    const radioName = item.referenceId;
    return (
      <Field
        type="radio"
        as={Radio}
        size="small"
        className="position-static"
        data-testid="mobile-radio-buttons"
        name={radioName}
        id={`${radioName}_${item.sosCode}`}
        label={
          <>
            <p className="u-fs--16 u-color--DarkGray mb-2">{item.sos}</p>
            <p className="u-fs--16 u-color--ExtraDarkGray my-1">
              {item.sosPartNumber}: {item.sosPartName}
            </p>
            <p className="u-color--DarkGray my-1">
              {t('REQUESTED_QUANTITY')}: {item.requestedQuantity}
            </p>

            <p className="d-flex flex-column u-color--ExtraDarkGray mt-1 mb-2 u-fs--16">
              <UnitPriceTableCell
                unitPrice={item?.unitPrice}
                coreCharges={item?.coreCharges}
                showCoreCharges={!!item?.coreCharges}
                currency={currency}
              />
            </p>
            <p className="mb-2">
              {getAvailability(
                item,
                isStoreAvailabilityEnabled,
                hoseAvailabilityLabel,
                sourcingToggle
              )}
            </p>
          </>
        }
        value={`${item.id}`}
      />
    );
  };

  const schema = [
    {
      translationKey: RADIO_BUTTON,
      value: ''
    }
  ];
  return (
    <div className="ms-2 mt-n1">
      {schema.map(
        element =>
          !!element?.translationKey && (
            <div className="row" key={`${element.translationKey}`}>
              {element?.translationKey === RADIO_BUTTON && (
                <div>{getRadio()}</div>
              )}
            </div>
          )
      )}
    </div>
  );
};

SOSTableMobileView.propTypes = {
  item: PropTypes.shape({
    sosPartNumber: PropTypes.string,
    sosPartName: PropTypes.string,
    unitPrice: PropTypes.string,
    sos: PropTypes.string,
    availability: PropTypes.arrayOf(
      PropTypes.shape({
        availabilityMessage: PropTypes.string,
        quantityAvailable: PropTypes.string
      })
    ),
    errors: PropTypes.shape({
      errorMessage: PropTypes.string,
      errorCode: PropTypes.string
    }),
    coreCharges: PropTypes.string,
    showCoreCharges: PropTypes.bool,
    sosCode: PropTypes.string,
    requestedQuantity: PropTypes.string,
    originalPartNumber: PropTypes.string,
    id: PropTypes.number,
    referenceId: PropTypes.string
  }),
  currency: PropTypes.string,
  sourcingToggle: PropTypes.bool
};

export default SOSTableMobileView;
